<script setup lang="ts">
/**
 * Section 47(2) — Notification Where Registers or Records are Not Kept at the Registered Address. M32018.
 * · records a~k 는 DCR 과 ctx.flag(record_*) 로 동기화.
 */
import { inject } from 'vue';
import { UPDATE_BUSINESS_ADDRESS_DOC_CTX } from './updateBusinessAddressContext';
import { RECORD_ITEMS } from './updateBusinessAddressFields';
import UpdateBusinessAddressDocVarField from './UpdateBusinessAddressDocVarField.vue';
import UpdateBusinessAddressSigners from './parts/UpdateBusinessAddressSigners.vue';

const ctx = inject(UPDATE_BUSINESS_ADDRESS_DOC_CTX)!;
</script>

<template>
  <div class="uba-doc">
    <div class="doc-head">
      <div class="doc-meta">COMPANIES ACT 2016</div>
      <div class="doc-meta">Section 47(2)</div>
      <div class="doc-company notice-title">
        NOTIFICATION WHERE REGISTERS OR RECORDS ARE NOT KEPT AT THE REGISTERED ADDRESS
      </div>
      <div class="doc-company" style="margin-top:8px"><UpdateBusinessAddressDocVarField field-key="company_name" /></div>
    </div>

    <p class="doc-p">
      <b>Address where registers/records are kept :</b>
      <UpdateBusinessAddressDocVarField field-key="address_line_1" />,
      <UpdateBusinessAddressDocVarField field-key="address_line_2" />,
      <UpdateBusinessAddressDocVarField field-key="address_line_3" />,
      <UpdateBusinessAddressDocVarField field-key="postcode" /> <UpdateBusinessAddressDocVarField field-key="city" />,
      <UpdateBusinessAddressDocVarField field-key="state" />, <UpdateBusinessAddressDocVarField field-key="country" />
    </p>

    <p class="doc-lbl-title">Type of registers/records kept at this address :</p>
    <ul class="rec-list">
      <li
        v-for="r in RECORD_ITEMS" :key="r.key"
        class="rec-item doc-toggle" :class="{ off: !ctx.flag(r.key) }"
        :title="ctx.flag(r.key) ? 'included — click to exclude' : 'excluded — click to include'"
        @click="ctx.toggleFlag(r.key)"
      >
        <span class="rec-mark">{{ ctx.flag(r.key) ? '☑' : '☐' }}</span>
        <span class="rec-tx">{{ r.text }} ;</span>
      </li>
    </ul>

    <p class="doc-p">
      <b>Effective date where registers/records are kept at this address :</b>
      <UpdateBusinessAddressDocVarField field-key="effective_date" />
    </p>
    <p class="doc-note">*Please use a different form if the address is different</p>

    <p class="doc-lbl-title">Declaration:</p>
    <p class="doc-p">I confirm that the facts and information stated in this document are true and to the best of my knowledge.</p>

    <p class="doc-p"><b>Signed:</b></p>
    <UpdateBusinessAddressSigners var-key="s47" />
    <p class="doc-p doc-sign-date"><b>Date :</b> <UpdateBusinessAddressDocVarField field-key="declaration_date" /></p>

    <div class="doc-attn">
      <b>Attention:</b>
      It is an offence under section 591 of the Companies Act 2016 to make or authorize the making of a statement
      that a person knows is false or misleading and that person may be liable, upon conviction, to imprisonment
      for a term not exceeding ten years or to a fine not exceeding RM3million or to both.
    </div>
  </div>
</template>

<style src="./updateBusinessAddressDoc.css"></style>
